import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { fetchSettingPageInfo, postSettingPageInfo } from "../../../../store/action/settingPageAction";
import OrderMethod from "./OrderMethod";
import SettingSyntax from "./SettingSyntax";
import SettingAutoReply from "./SettingAutoReply";
import SettingAutoComment from "./SettingAutoComment";
import SettingAdvanced from "./SettingAdvanced";
import SettingTransport from "./SettingTransport";
import { Link, useNavigate, useParams } from "react-router-dom";
import { URL } from "../../../../routers/constants";
import { replaceNavigate } from "../../../../services/helpers/Helper";
import Modal from "../../../shared/components/modal";
import { createCampaign } from "../../../../store/action/campaignsAction";
import { COMMENT_TYPE, METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";
const _ = require('lodash');

const Index = (props) => {
   const { page, fetchSettingPageInfo, postSettingPageInfo, createCampaign, settingPage } = props;
   const params = useParams();
   const navigate = useNavigate();
   const {
      type,
      type_comment
   } = settingPage;
   const { id } = params;
   const [isOpenModal, setIsOpenModal] = useState(false);

   useEffect(() => {
      if (!_.isEmpty(page)) {
         fetchSettingPageInfo(id);
      }
   }, [page]);

   const getLinkReturn = () => {
      return id ? replaceNavigate(URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT, id) : URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST;
   }

   const handleSaveSettingPageInfo = () => {
      postSettingPageInfo(id).then((response) => {
         setIsOpenModal(true);
      });
   }

   return (
      <div id="bot-scene-container" className="">
         <div id="bot-scene-content" className="scroll-light">
            <div className="header-live-stream-container app-v2-header-wrapper">
               <div className="header-live-stream-left-side">
                  <Link to={getLinkReturn()}>
                     <button type="button" className="app-btn app-btn-link app-btn-pd-none button-back-onboarding mr16">
                        <div className="svg-next-icon ic-arrow-left" >
                        </div>
                     </button>
                  </Link>
                  <div className="header-left-side-layout">
                     <div className="header-live-stream-title-container">
                        <div className="header-live-stream-title">
                           <div className="wrapper-header-title" title="Cấu hình chung">
                              <span className="title-header-live-stream">
                                 Cấu hình chung
                              </span>
                           </div>
                        </div><span className="header-live-stream-sub-title"></span>
                     </div>
                  </div>
               </div>
               <div className="header-live-stream-right-side"></div>
            </div>
            <div className="default-setting-wrapper">
               <div className="setting-wrapper">
                  <div className="wrapper">
                     <OrderMethod />
                     <SettingSyntax />
                     <SettingAutoReply />
                     <SettingAutoComment />
                     <SettingAdvanced />
                     <SettingTransport />
                     <div className="flex-display-justify-content-center">
                        <button type="button" className="app-btn app-btn-primary" onClick={handleSaveSettingPageInfo}>
                           <div className="svg-next-icon mr10 ic-save-outline-white-2">
                           </div>Lưu cấu hình
                        </button>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {isOpenModal &&
            <Modal>
               <div className="modal-dialog app-modal app-v2-modal popup-setting-default-success modal-md" role="document">
                  <div className="modal-content">
                     <div className="app-modal-header">
                        <h4 className="app-modal-title">
                           <div className="app-v2-modal-header">
                              <div className="custom">
                                 <div className="svg-next-icon icon-img-tick">
                                 </div>
                                 <span className="title-success">Cấu hình chung đã được cập nhật thành công</span>
                              </div>
                           </div>
                        </h4>
                        <span className="app-close" onClick={() => setIsOpenModal()}>
                           <svg className="app-svg-inline-block" width="20px" height="20px" viewBox="0 0 24 24">
                              <g> <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"> </path></g>
                           </svg>
                        </span>
                     </div>
                     <div className="app-modal-body">
                        <div className="body-popup-success-wapper">
                           <div className="body-popup-success-box">
                              <div className="body-popup-success-line first-line">
                                 <span className="body-popup-success-line-title">
                                    Phương thức chốt đơn:
                                 </span>
                                 <span className="body-popup-success-line-option">
                                    {type === METHOD_TYPE.AUTO ? "Chốt đơn tự động" : "Chốt đơn thủ công"}
                                 </span>
                              </div>
                              <div className="body-popup-success-line">
                                 <span className="body-popup-success-line-title">
                                    Cú pháp khách bình luận để chốt đơn:
                                 </span>
                                 <span className="body-popup-success-line-option">
                                    {type_comment == COMMENT_TYPE.FULL_KEYWORD ? "Bình luận có chứa Mã sản phẩm, Mã biến thể (nếu có) và Số điện thoại" : "Bình luận có chứa Mã sản phẩm"}
                                 </span>
                              </div>
                           </div>
                           <div className="mt10">
                              <Link to={URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST}>
                                 <button type="button" className="app-btn app-btn-default mr16">
                                    Quay về danh sách
                                 </button>
                              </Link>
                              <button type="button" className="app-btn app-btn-primary" onClick={() => createCampaign(navigate)}>
                                 Tạo kịch bản
                              </button>
                           </div>
                        </div>
                     </div>
                     <div className="app-modal-footer">
                        <div className="col-auto"></div>
                     </div>
                  </div>
               </div>
            </Modal>}
      </div>
   )
}

const mapStateToProps = (state) => {
   const { page, settingPage } = state;
   return {
      page,
      settingPage
   };
};

export default connect(mapStateToProps, {
   fetchSettingPageInfo,
   postSettingPageInfo,
   createCampaign
})(Index);